import type { TISAUser } from '@/types/tisa-coins';
import { sortEventsByDate } from '@/lib/tisa-helpers';

interface Props {
  user: TISAUser;
}

export function RecentActivitySection({ user }: Props) {
  // Combine all events and sort by date
  const allEvents: Array<{type: string, text: string, created_at: string, color: string}> = [
    ...user.xp_events.map(e => ({
      type: 'XP',
      text: `+${e.amount} XP from ${e.source}`,
      created_at: e.created_at,
      color: 'text-emerald'
    })),
    ...user.coin_events.filter(e => e.status === 'approved').map(e => ({
      type: 'Coin',
      text: `${e.amount > 0 ? '+' : ''}${e.amount} coins (${e.type})`,
      created_at: e.created_at,
      color: 'text-gold'
    })),
    ...user.badge_events.map(e => ({
      type: 'Badge',
      text: `Earned badge (${e.tier})`,
      created_at: e.created_at,
      color: 'text-purple'
    }))
  ];

  const recentEvents = sortEventsByDate(allEvents, 'desc').slice(0, 5);

  return (
    <div className="bg-gray-900/50 border-2 border-gray-700/50 rounded-xl p-6">
      <h2 className="text-xl font-cinzel font-bold text-white mb-4">
        📜 Recent Activity
      </h2>
      {recentEvents.length === 0 ? (
        <p className="text-gray-400 text-sm text-center py-4">No activity yet!</p>
      ) : (
        <div className="space-y-2">
          {recentEvents.map((event, i) => (
            <div key={i} className="bg-black/20 rounded-lg p-2 border border-gray-700/30">
              <p className={`text-sm font-poppins ${event.color}`}>{event.text}</p>
              <p className="text-xs text-gray-500 mt-1">
                {new Date(event.created_at).toLocaleDateString()}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
